import React from "react";
import { ArrowBackCircle, ArrowForwardCircle, ArrowBackOutline, ArrowForwardOutline, AddOutline, Close } from 'react-ionicons'
import { Modal } from 'react-bootstrap';
import constantURI from "../URI"
import _post from "../Functions/Post"
import SearchFilterFunction from "../Functions/SearchFilter"
import FilterFunction from "../Functions/Filter"
import stylesMed from "./stylesMed"
import Authenticate from "../Functions/MedRepAuthenticate"

export default class HCPs extends React.Component {

    constructor() {
        super();
        this.state = {
            clients: [],
            clientsCopy: [],
            loading: true,
            noData: true,
            backShow: false,
            checked: [],
            addRoute: false,
            showButtons: [],
            showInputs: [],
            index: [],
            logistic: [],
            qty: [],
            logistics: [],
            showAlert: false,
            logIndex: 0,
            itemIndex: 0,
            clientIndex: 0,
            preventSymbols: ["e", "E", "+", "-", "."],
            offset: 0,
            offsetFixed: 0,
            user: "",
            Reps: [],
            token: "",
            doctors: false,
            pharmacies: false,
            clear: true,
            specialRequest: [],
            expectedTime: [],
            checkedIndex: [],
            isSupervisor: true,
            authenticate: false,
            areas: [],
            area: "",
            specialties: [],
            specialty: "",
            subareas: [],
            allSubareas: [],
            subarea: "",
            areaID: 0,
            clientWithFilter: [],
            alertUndefined: false
        }
    }

    async componentDidMount() {
        // await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        if (this.props.show !== undefined) {
            this.setState({ backShow: this.props.show });
        }
        if (this.props.addRoute !== undefined) {
            this.setState({ addRoute: this.props.addRoute });
        }
        const checked = localStorage.getItem('CheckedDoctors');
        const user = localStorage.getItem('User');
        const token = localStorage.getItem('Token');
        var supervisor = localStorage.getItem("isSupervisor");
        await this.setState({ user: JSON.parse(user), token: JSON.parse(token), isSupervisor: JSON.parse(supervisor) });
        if (checked !== null)
            this.setState({ checked: JSON.parse(checked), showButtons: JSON.parse(checked) });

        const clientsURL = constantURI() + "odooController/MedRepRead";
        const RepsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.users",
                "args": [],
                "kwargs": {
                    "fields": ["name", "supervisor"],
                    "domain": [["supervisor", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const specialtiesBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "x_specialties",
                "args": [],
                "kwargs": {
                    "fields": ["x_name"]
                }
            },
            "token": this.state.token
        }
        const areaBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.country.state",
                "args": [],
                "kwargs": {
                    "fields": ["name"]
                }
            },
            "token": this.state.token
        }
        const subareaBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "x_res.city",
                "args": [],
                "kwargs": {
                    "fields": ["x_name", "x_country_state_id"],
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(clientsURL, RepsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ Reps: data.result });
                        localStorage.setItem('Reps', JSON.stringify(this.state.Reps));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(clientsURL, specialtiesBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ specialties: data.result })
                        localStorage.setItem('Specialties', JSON.stringify(this.state.specialties));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(clientsURL, areaBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ areas: data.result })
                        localStorage.setItem('Area', JSON.stringify(this.state.areas));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(clientsURL, subareaBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ allSubareas: data.result })
                        localStorage.setItem('Subareas', JSON.stringify(this.state.allSubareas));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const specialtiesRaw = localStorage.getItem('Specialties');
            const areasRaw = localStorage.getItem('Area');
            const repsRaw = localStorage.getItem('Reps');
            const subareasRaw = localStorage.getItem('Subareas');

            const parsedReps = repsRaw ? JSON.parse(repsRaw) : [];
            const parsedSpecialties = specialtiesRaw ? JSON.parse(specialtiesRaw) : [];
            const parsedAreas = areasRaw ? JSON.parse(areasRaw) : [];
            const parsedSubareas = subareasRaw ? JSON.parse(subareasRaw) : [];

            await this.setState({ Reps: parsedReps, specialties: parsedSpecialties, areas: parsedAreas, allSubareas: parsedSubareas });
        }

        if (this.state.Reps.length === 0) {
            const clientsBody = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "res.partner",
                    args: [],
                    kwargs: {
                        fields: ["name", "street", "phone", "potential", "cf", "state_id", "x_specialty_id", "clienttype", "x_month_visits", "x_city_id"],
                        domain: [["x_repuser", "=", this.state.user]]
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(clientsURL, clientsBody).then((response) => {
                    return response.json().then((data) => {
                        if (data.result !== undefined) {
                            this.setState({ clients: data.result, clientsCopy: data.result, clientWithFilter: data.result, loading: false })
                            localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                const clients = localStorage.getItem('HCPs');
                this.setState({ clients: JSON.parse(clients), clientsCopy: JSON.parse(clients), clientWithFilter: JSON.parse(clients), loading: false });
            }
        }
        else {
            this.state.Reps.forEach(async (item, index, arr) => {
                const clientsBody = {
                    jsonrpc: "2.0",
                    params: {
                        method: "search_read",
                        model: "res.partner",
                        args: [],
                        kwargs: {
                            fields: ["name", "street", "phone", "potential", "state_id", "x_specialty_id", "clienttype"],
                            domain: [["x_repuser", "=", item.name]]
                        }
                    },
                    "token": this.state.token
                }
                if (this.state.authenticate) {
                    await _post(clientsURL, clientsBody).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined) {
                                const tempClients = this.state.clients;
                                await tempClients.push.apply(tempClients, data.result);
                                this.setState({ clients: tempClients, clientsCopy: tempClients, clientWithFilter: tempClients })
                                localStorage.setItem('HCPsSupervisor', JSON.stringify(this.state.clients));
                                localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                                if (index === arr.length - 1)
                                    this.setState({ loading: false })
                            }
                            else {
                                this.setState({ alertUndefined: true });
                            }
                        })
                    })
                }
                else {
                    const clients = localStorage.getItem('HCPsSupervisor');
                    this.setState({ clients: JSON.parse(clients), clientsCopy: JSON.parse(clients), clientWithFilter: JSON.parse(clients), loading: false });
                }
            })
            const clientsBodyForRep = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "res.partner",
                    args: [],
                    kwargs: {
                        fields: ["name", "street", "phone", "potential", "state_id", "x_specialty_id", "clienttype"],
                        domain: [["x_repuser", "=", this.state.user]]
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(clientsURL, clientsBodyForRep).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            const tempClients = this.state.clients;
                            await tempClients.push.apply(tempClients, data.result);
                            this.setState({ clients: tempClients, clientsCopy: tempClients, clientWithFilter: tempClients })
                            localStorage.setItem('HCPsSupervisor', JSON.stringify(this.state.clients));
                            localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                            this.setState({ clients: this.sortNames(this.state.clients) });
                        }
                    })
                })
            }
        }
    }

    sortNames = (array) => {
        const sortedNames = array.slice().sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        return sortedNames;
    }

    onChangeSpecialty = async (e) => {
        await this.setState({ specialty: e.target.value });
        var values = await FilterFunction(this.state.specialty, this.state.clientWithFilter, this.state.clientWithFilter, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
        var values = await FilterFunction(this.state.area, this.state.clients, this.state.clients, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
        var values = await FilterFunction(this.state.subarea, this.state.clients, this.state.clients, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
    }

    onChangeArea = async (e) => {
        await this.setState({ area: e.target.value });
        await this.state.areas.map(async (item) => {
            if (item.name === this.state.area)
                this.setState({ areaID: item.id });
        })
        const tempSubarea = [];
        await this.state.allSubareas.forEach((item) => {
            if (item.x_country_state_id[0] === this.state.areaID) {
                tempSubarea.push(item);
            }
        })
        await this.setState({ subareas: tempSubarea });

        var values = await FilterFunction(this.state.specialty, this.state.clientWithFilter, this.state.clientWithFilter, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
        var values = await FilterFunction(this.state.area, this.state.clients, this.state.clients, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });

    }

    onChangeSubarea = async (e) => {
        this.setState({ subarea: e.target.value });
        var values = await FilterFunction(this.state.specialty, this.state.clientWithFilter, this.state.clientWithFilter, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
        var values = await FilterFunction(this.state.area, this.state.clients, this.state.clients, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
        var values = await FilterFunction(this.state.subarea, this.state.clients, this.state.clients, this.state.noData);
        await this.setState({ clients: values.items, noData: values.noData });
    }

    closeAlert = () => {
        this.setState({ showAlert: false });
    }

    showAlert = (logIndex, index, clientIndex) => {
        this.setState({ showAlert: true, logIndex: logIndex, itemIndex: index, clientIndex: clientIndex });
    }

    onDeleteItem = async (logIndex, itemIndex, clientIndex) => {
        var log = this.state.logistic[logIndex];
        log.splice(itemIndex, 1);
        this.setState({ ...this.state.logistic[logIndex] = log });
        var qty = this.state.qty[logIndex];
        qty.splice(itemIndex, 1);
        this.setState({ ...this.state.qty[logIndex] = qty });
        var clientLogs = {};
        await this.state.logistic[logIndex].map((item2, index2) => {
            clientLogs[item2] = this.state.qty[logIndex][index2];
        })
        var clientLogsItems = this.state.logistics;
        clientLogsItems[clientIndex] = {};
        clientLogsItems[clientIndex] = clientLogs;
        await this.setState({ logistics: clientLogsItems });
        localStorage.setItem("ActivityLogistics", JSON.stringify(this.state.logistics));
    }

    onPressClient = async (item, index) => {
        if (this.state.backShow) {
            await this.setState({ ...this.state.showButtons[index] = !this.state.showButtons[index] });
            await this.setState({ ...this.state.checked[index] = !this.state.checked[index] });
            await localStorage.setItem('CheckedDoctors', JSON.stringify(this.state.checked));
            if (this.state.index[index] === undefined) {
                await this.setState({ ...this.state.index[index] = -1 });
            }
            if (this.state.qty[index] === undefined) {
                await this.setState({ ...this.state.qty[index] = [] });
            }
            if (this.state.logistic[index] === undefined) {
                await this.setState({ ...this.state.logistic[index] = [] });
            }
        }
        else if (!this.state.addRoute && !this.state.backShow) {
            localStorage.setItem('HCP', JSON.stringify(item));
            this.props.history.push("/HCPDetail");
        }
    }

    onChangeLogistic = (index) => async (e) => {
        this.setState({ ...this.state.logistic[index][this.state.index[index]] = e.target.value });
    }

    onChangeQty = (index) => async (e) => {
        this.setState({ ...this.state.qty[index][this.state.index[index]] = e.target.value });
    }

    onAddLog = async (index) => {
        await this.setState({ ...this.state.showInputs[index] = !this.state.showInputs[index] });
        if (this.state.showInputs[index]) {
            this.setState({ ...this.state.index[index] = this.state.index[index] + 1 });
        }
        else {
            this.state.logistic[index].length = this.state.logistic[index].length + 1;
            var clientLogs = {};
            await this.state.logistic[index].map((item2, index2) => {
                clientLogs[item2] = this.state.qty[index][index2];
            })
            var clientLogsItems = this.state.logistics;
            clientLogsItems[index] = {};
            clientLogsItems[index] = clientLogs;
            await this.setState({ logistics: clientLogsItems });
            localStorage.setItem("ActivityLogistics", JSON.stringify(this.state.logistics));
        }
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.clientsCopy, this.state.clientsCopy, this.state.noData);
        this.setState({ clients: values.items, noData: values.noData })
    }

    onPressAddRoute = (item) => {
        localStorage.setItem('HCP', JSON.stringify(item));
        localStorage.setItem('CheckedDoctors', JSON.stringify(this.state.checked));
        this.props.history.push("/HCPDetail");
    }

    onCheck = async (newValue, id) => {
        this.setState({ ...this.state.checked[id] = newValue.nativeEvent.target.checked });
        await this.state.clientsCopy.map(async (item, index) => {
            if (Number(item.id) === id) {
                await this.setState({ ...this.state.checkedIndex[index] = id });
            }
        })
        localStorage.setItem('CheckedDoctors', JSON.stringify(this.state.checked));
        localStorage.setItem('CheckedDoctorsIndex', JSON.stringify(this.state.checkedIndex));
    }

    onClickDoctors = async () => {
        await this.setState({ doctors: true, pharmacies: false, clear: false });
        const temp = [];
        await this.state.clientsCopy.forEach((item) => {
            if (item.clienttype[0] === 1) {
                temp.push(item);
            }
        })
        this.setState({ clients: temp, clientWithFilter: temp });
    }

    onClickPharmacies = async () => {
        await this.setState({ doctors: false, pharmacies: true, clear: false });
        const temp = [];
        await this.state.clientsCopy.forEach((item) => {
            if (item.clienttype[0] === 2) {
                temp.push(item);
            }
        })
        this.setState({ clients: temp, clientWithFilter: temp });
    }

    onClickClear = async () => {
        await this.setState({
            doctors: false, pharmacies: false, clear: true, clientWithFilter: this.state.clientsCopy, clients: this.state.clientsCopy,
            area: "", specialty: "", subarea: ""
        });
    }

    Header = () => {
        {
            return (
                <div>
                    {(!this.state.backShow && !this.state.addRoute) ?
                        <div className="row">
                            <div className="pt-3 col">
                                <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")}
                                    color={'#00bfff'} height="50px" width="50px" />
                            </div>
                            {(this.state.isSupervisor) ? null :
                                <div className="col" style={stylesMed.rightDirection}>
                                    <AddOutline className="btn" color={'#00bfff'} height="50px" width="50px"
                                        onClick={() => this.props.history.push("./AddClient")} />
                                    <h6>Add HCP</h6>
                                </div>

                            }
                        </div>
                        : null
                    }
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="pt-3 row mt-1">
                        <div className="col" style={stylesMed.displaySearch}>
                            <input type="text" className="form-control" id="search" style={stylesMed.searchInputHalf} placeholder="Search Here" onChange={text => this.onSearch(text)} />
                            <Close className="btn" onClick={() => { this.onClickClear(); document.getElementById('search').value = ""; }} color={'#00bfff'} height="20px" width="20px" />
                        </div>
                        <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.doctors) ? stylesMed.wideButtonFilter : null}
                            onClick={() => this.onClickDoctors()}>Doctors</div>
                        <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.pharmacies) ? stylesMed.wideButtonFilter : null}
                            onClick={() => this.onClickPharmacies()}>Pharmacies</div>
                        <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.clear) ? stylesMed.wideButtonFilter : null}
                            onClick={() => this.onClickClear()}>CLEAR FILTERS</div>
                    </div>
                    <div className="row mt-3">
                        <div className="col form-group">
                            <label>Specialty:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.specialty} onChange={this.onChangeSpecialty}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.specialties.map((item) => {
                                    return (
                                        <option value={item.x_name}>{item.x_name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                        <div className="col form-group">
                            <label>Area:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.area} onChange={this.onChangeArea}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.areas.map((item) => {
                                    return (
                                        <option value={item.name}>{item.name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                        <div className="col form-group">
                            <label>Subarea:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.subarea} onChange={this.onChangeSubarea}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.subareas.map((item) => {
                                    return (
                                        <option value={item.x_name}>{item.x_name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                    </div>
                    {
                        (this.state.addRoute) ? null :
                            <p className="pt-3 text-center h3">HCP List</p>
                    }
                </div>
            )
        }
    }

    onPrevious = async () => {
        await this.setState({ offset: this.state.offset - 6, offsetFixed: this.state.offsetFixed - 1 })
        if (this.state.offset < 0) {
            this.setState({ offset: 0, offsetFixed: 0 });
        }
    }

    onNext = async () => {
        await this.setState({ offset: this.state.offset + 6, offsetFixed: this.state.offsetFixed + 1 })
        if (this.state.clients.slice(this.state.offset, this.state.offset + 6).length === 0) {
            this.setState({ offset: this.state.offset - 6, offsetFixed: this.state.offsetFixed - 1 })
        }
    }

    onChangeSpecialRequest = (newValue, index) => {
        this.setState({ ...this.state.specialRequest[index] = newValue.target.value });
        localStorage.setItem('SpecialRequest', JSON.stringify(this.state.specialRequest));
    }

    onChangeExpectedTime = (newValue, index) => {
        this.setState({ ...this.state.expectedTime[index] = newValue.target.value });
        localStorage.setItem('ExpectedTime', JSON.stringify(this.state.expectedTime));
    }

    onClickHistory = (id, name) => {
        localStorage.setItem("HistoryID", JSON.stringify(id));
        localStorage.setItem("HistoryName", JSON.stringify(name));
        this.props.history.push("/HCPDetail");
    }

    render() {
        if (!this.state.loading && this.state.clients.length >= 0) {
            return (
                <div className="container-fluid" style={stylesMed.mainContainer}>
                    {this.Header()}
                    <div className="pt-2 vh-100">
                        {this.state.clients.slice(this.state.offset, this.state.offset + 6).map((client, clientIndex) => {
                            return (
                                <div key={clientIndex}>
                                    <div className="pt-3" style={stylesMed.mainBackgroundColor} onClick={() => this.onPressClient(client.name, client.id)}>
                                        <div className="row" style={stylesMed.checkDiv}>
                                            {(this.state.backShow) ?
                                                <div className="col-1 m-2">
                                                    <input type="checkbox" className="form-check-input" style={stylesMed.checkbox}
                                                        checked={(this.state.checked[client.id] === undefined || this.state.checked[client.id] === null) ? false : this.state.checked[client.id]}
                                                    />
                                                </div>
                                                : null
                                            }
                                            {(this.state.addRoute) ?
                                                <div className="col-1 m-2">
                                                    <input type="checkbox" className="form-check-input" style={stylesMed.checkbox}
                                                        checked={(this.state.checked[client.id] === undefined || this.state.checked[client.id] === null) ? false : this.state.checked[client.id]}
                                                        value={(this.state.checked[client.id] === undefined || this.state.checked[client.id] === null) ? false : this.state.checked[client.id]}
                                                        onChange={(newValue) => this.onCheck(newValue, client.id)} />
                                                </div>
                                                : null
                                            }
                                            <div className="col-4" style={{ width: "400px" }} onClick={(this.state.addRoute) ? () => this.onPressAddRoute(client.name) : null}>
                                                <div>
                                                    <p style={stylesMed.clientName}>{client.name} - {client.x_specialty_id[1]}</p>
                                                    <p style={stylesMed.clientDetail}>{client.street}</p>
                                                    <p style={stylesMed.clientDetail}>{client.phone}</p>
                                                    <p style={stylesMed.clientDetail}>Class: {client.potential[1]} -- Frequency: {client.cf}</p>
                                                </div>
                                            </div>
                                            {(this.state.addRoute) ?
                                                <div className="col-4 d-flex align-items-center justify-content-center">
                                                    <div className="row">
                                                        <p>Remaining Visits: {client.x_month_visits} </p>
                                                        <input className="form-control" style={stylesMed.reportClientInput}
                                                            placeholder="Special Request" disabled={!this.state.checked[client.id]}
                                                            value={(this.state.specialRequest[client.id] === undefined) ? "" : this.state.specialRequest[client.id]}
                                                            onChange={(newValue) => this.onChangeSpecialRequest(newValue, client.id)} />
                                                        {/*<input className="form-control" style={stylesMed.reportClientInput}*/}
                                                        {/*    placeholder="Expected Start Time" disabled={!this.state.checked[client.id]}*/}
                                                        {/*    value={(this.state.expectedTime[client.id] === undefined) ? "" : this.state.expectedTime[client.id]}*/}
                                                        {/*    onChange={(newValue) => this.onChangeExpectedTime(newValue, client.id)} />*/}
                                                    </div>
                                                </div>
                                                : null
                                            }
                                            {(!this.state.backShow && !this.state.addRoute) ?
                                                <div className="col d-flex flex-row-reverse"
                                                    onClick={(this.state.addRoute) ? () => this.onPressAddRoute(client.name) : null}>
                                                    <ArrowForwardCircle className="btn" color={'#00bfff'} height="35px" width="35px" />
                                                </div> : null
                                            }
                                            {/*{(this.state.addRoute) ?*/}
                                            {/*    <div className="col pt-2 d-flex align-items-center justify-content-center">*/}
                                            {/*        <div className="btn" style={stylesMed.deleteButton} onClick={() => this.onClickHistory(client.id, client.name)}>History</div>*/}
                                            {/*    </div> :*/}
                                            {/*    null*/}
                                            {/*}*/}
                                        </div>
                                    </div>
                                    {(this.state.showButtons[client.id] && this.state.backShow) ?
                                        <div>
                                            <div className="col pt-2 d-flex align-items-center justify-content-center">
                                                <div className="btn" style={stylesMed.wideButton} onClick={() => this.onAddLog(client.id)}>Add Logistic</div>
                                            </div>
                                            {(this.state.showInputs[client.id]) ?
                                                <div>
                                                    {this.state.logistic.map((log, logIndex) => {
                                                        if (logIndex === client.id) {
                                                            return (
                                                                log.map((item, index, arr) => {
                                                                    if (index !== arr.length - 1) {
                                                                        return (
                                                                            <div className="row m-1" key={index}>
                                                                                <div className="col mt-1">
                                                                                    <div className="btn" style={stylesMed.deleteButton}
                                                                                        onClick={() => this.showAlert(logIndex, index, client.id)}>Delete</div>
                                                                                </div>
                                                                                <h6 className="col d-flex justify-content-center mt-1">{item}</h6>
                                                                                <h6 className="col d-flex justify-content-center mt-1">
                                                                                    {this.state.qty[logIndex][index]}</h6>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    else return null
                                                                })
                                                            )
                                                        }
                                                        else return null
                                                    })}
                                                    <div className="row m-2">
                                                        <div className="col d-flex align-items-center justify-content-center">
                                                            <input className="form-control" onChange={this.onChangeLogistic(client.id)}
                                                                placeholder="Logistic" style={stylesMed.logisticInputs} />
                                                        </div>
                                                        <div className="col d-flex flex-row-reverse align-items-center justify-content-center">
                                                            <input className="form-control" onChange={this.onChangeQty(client.id)}
                                                                placeholder="Quantity" type="number"
                                                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()}
                                                                min="1" style={stylesMed.logisticInputs} />
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div>
                                                    {this.state.logistic.map((log, logIndex) => {
                                                        if (logIndex === client.id) {
                                                            return (
                                                                log.map((item, index) => {
                                                                    return (
                                                                        <div className="row m-1" key={index}>
                                                                            <div className="col mt-1">
                                                                                <div className="btn" style={stylesMed.deleteButton}
                                                                                    onClick={() => this.showAlert(logIndex, index, client.id)}>Delete</div>
                                                                            </div>
                                                                            <h6 className="col d-flex justify-content-center mt-1">{item}</h6>
                                                                            <h6 className="col d-flex justify-content-center mt-1">
                                                                                {this.state.qty[logIndex][index]}</h6>
                                                                        </div>
                                                                    )
                                                                })
                                                            )
                                                        }
                                                        else return null
                                                    })}
                                                </div>
                                            }
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                            )
                        })}
                        <div className="row fixed-bottom" style={stylesMed.mainBackgroundColor}>
                            <div className="col">
                                <ArrowBackOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onPrevious()} />
                                <h6>Previous HCPs</h6>
                            </div>
                            <div className="col" style={stylesMed.rightDirection}>
                                <ArrowForwardOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onNext()} />
                                <h6>Next HCPs</h6>
                            </div>
                        </div>
                        <Modal show={this.state.showAlert} onHide={this.closeAlert} animation={false}>
                            <Modal.Header>
                                <Modal.Title>Are you sure you want to delete this item?</Modal.Title>
                            </Modal.Header>
                            <Modal.Body><div>
                                <div className="btn" style={stylesMed.deleteButtonAlert}
                                    onClick={() => { this.onDeleteItem(this.state.logIndex, this.state.itemIndex, this.state.clients.id); this.closeAlert() }}>Delete</div>
                                <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}
                                    onClick={() => this.closeAlert()}>Cancel</div>
                            </div></Modal.Body>
                        </Modal>
                    </div>
                </div >
            );
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {this.Header()}
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}

